import { ConversationPanelFrame } from "@circle-react-uikit/CircleAIAppShell/Layout/ConversationPanel/ConversationPanelFrame";
import { LAYOUT_CONFIG } from "@circle-react-uikit/CircleAIAppShell/Layout/defaults";
import { type PropsWithChildren } from "react";
import { useShallow } from "zustand/react/shallow";

import { useAvatarConversationPanelStore } from "../useAvatarConversationPanelStore";

interface RootProps {
  "aria-label": string;
  resizeAriaLabel: string;
}

export const Root = ({
  children,
  "aria-label": ariaLabel,
  resizeAriaLabel,
}: Readonly<PropsWithChildren<RootProps>>) => {
  const { panelState, panelWidth, setPanelWidth } =
    useAvatarConversationPanelStore(
      useShallow(s => ({
        panelState: s.panelState,
        panelWidth: s.panelWidth,
        setPanelWidth: s.setPanelWidth,
      })),
    );

  return (
    <ConversationPanelFrame
      aria-label={ariaLabel}
      resizeAriaLabel={resizeAriaLabel}
      data-testid="avatar-conversation-panel"
      side="right"
      panelState={panelState}
      storedWidth={panelWidth}
      onWidthChange={setPanelWidth}
      minWidth={LAYOUT_CONFIG.conversationPanel.minWidth}
      maxWidth={LAYOUT_CONFIG.conversationPanel.maxWidth}
    >
      {children}
    </ConversationPanelFrame>
  );
};

Root.displayName = "Avatars.ConversationPanel.Root";
